import AdvancingTemplateDetailApp from "advancingtemplates/Detail/app";
import AdvancingTemplateList from "advancingtemplates/list/App";
import AdvancingTemplateNewApp from "advancingtemplates/New/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const advancingTemplateRoute: RouteObject = {
  path: "advancingtemplate",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: AdvancingTemplateList,
  }, {
    path: "new",
    loader: () => viewModel,
    Component: AdvancingTemplateNewApp,
  }, { 
    path: "detail/:key",
    loader: () => viewModel,
    Component: AdvancingTemplateDetailApp,
  }]
};